import React, { useState, useEffect } from 'react';
import { AlertMessage, PreviewImage, EyeIcon } from 'components';

import './input-file.scss';
export function InputFile({ getBinaryImage, id, invalid, getNameImage, file }) {

  const FILE_MAX_SIZE = 1000000;
  const MESSAGE_MAX_SIZE = "O arquivo escolhido excede o tamanho máximo de 1MB permitido! Escolha uma imagem menor e tente novamente.";
  const [classInput, setClassInput] = useState();
  const [active, setActive] = useState(false);
  const [message, setMessage] = useState("");
  const [imageUrl, setImageURL] = useState();
  const [imageInfo, setImageInfo] = useState();
  const [binaryImage, setBinaryImage] = useState();
  const [openPreview, setOpenPreview] = useState(false);
  const [inputFeedback, setInputFeedback] = useState("Selecione um arquivo");
  const [buttons, setButtons] = useState(true);
  const [backupURL, setBackupURL] = useState(false);

  const toggle = () => {
    setActive(!active);
  }

  const togglePreview = () => {
    setOpenPreview(!openPreview);
  }

  const cancelTogglePreview = () => {
    if(file?.directory) setImageURL(backupURL);
    setOpenPreview(!openPreview);
  }

  const showError = () => {
    setMessage(MESSAGE_MAX_SIZE);
    toggle();
  }

  useEffect(() => {
    invalid ? setClassInput("custom-file-label form-control is-invalid") : setClassInput("custom-file-label")
  }, [invalid]);

  const getImageDimensions = (url, name) => {
    let img = new Image();
    img.src = url
    img.onload = () => {
      setImageInfo({
        width: img.width,
        height: img.height,
        name
      })
    };
  }

  const getValue = (event) => {

    try {
      setBackupURL(imageUrl);
      const photo = event.target.files[0];
      const url = window.URL.createObjectURL(photo);
      const size = photo?.size || 0;

      getImageDimensions(url, photo?.name);
      setImageURL(url);

      if (size < FILE_MAX_SIZE) {
        setBinaryImage(photo);
        setButtons(true);
        setOpenPreview(!openPreview);
      } else {
        getNameImage(null);
        showError();
      }

    } catch (error) {
      console.log(error);
    }
  }

  const confirmImage = (photo, id) => {
    try {
      getBinaryImage(photo, id);
      getNameImage(photo?.name);
      setInputFeedback(photo?.name);
    } catch (error) {
      console.log(error);
    }
  }

  const openView = () => {
    togglePreview();
    setButtons(false);
  }

  const renderIconView = (viewed) => {
    if (viewed !== "Selecione um arquivo" || file?.value?.directory) {
      return (
        <div class="input-group-append">
          <span onClick={openView} class="input-group-text">
            <EyeIcon />
          </span>
        </div>
      )
    }
  }

  const getInputFeedback = ()=> {
    const altImage =  file?.value?.name ? file?.value?.name : inputFeedback;
    return altImage.substring(0,30);
  }

  return (
    <div class="input-group mb-3">
      <div class="custom-file">
        <input type="file" accept="image/x-png, image/jpeg" onChange={getValue} class="custom-file-input" />
        <label class={classInput}> { getInputFeedback() } </label>
      </div>
      {renderIconView(inputFeedback)}
      <AlertMessage message={message} active={active} toggle={toggle} />
      <PreviewImage open={openPreview} buttons={buttons} image={imageUrl} dimensions={imageInfo} id={id} togglePreview={togglePreview} cancelPreview={cancelTogglePreview} confirmImage={() => confirmImage(binaryImage, id)} file={file} />
    </div>
  )
}
